import DOMPurify from 'isomorphic-dompurify';

type RenderSimpleHtmlProps = {
    html: string;
    className?: string;
};

const RenderSimpleHtml = (props: RenderSimpleHtmlProps) => {
    const { html, className } = props;

    const sanitizedData = () => ({
        __html: DOMPurify.sanitize(html),
    });

    return <div className={className} dangerouslySetInnerHTML={sanitizedData()} />;
};

export default RenderSimpleHtml;
